import Divider, { type DividerProps } from "@mui/material/Divider";
import { styled } from "@mui/material/styles";

export const StyledDivider = styled(Divider)<DividerProps>(({ theme }) => ({
  color: theme.palette.text.secondary,
  marginTop: theme.spacing(3),
  marginBottom: theme.spacing(3),
}));
